import API from "../../services/api";

/*
|--------------------------------------------------------------------------
| Admin Users
|--------------------------------------------------------------------------
*/

export const getAdminUsers = () =>
    API.get("/admin/admin-users");

export const getAdminUserById = (id) =>
    API.get(`/admin/admin-users/${id}`);

export const createAdminUser = (data) =>
    API.post("/admin/admin-users", data);

export const updateAdminUser = (id, data) =>
    API.put(`/admin/admin-users/${id}`, data);

export const updateAdminStatus = (id, status) =>
    API.patch(`/admin/admin-users/${id}/status`, {
        status,
    });

export const resetAdminPassword = (id, password) =>
    API.patch(`/admin/admin-users/${id}/password`, {
        password,
    });

export const deleteAdminUser = (id) =>
    API.delete(`/admin/admin-users/${id}`);